"use client";
import { jsx as o, jsxs as n } from "react/jsx-runtime";
import * as e from "@radix-ui/react-dialog";
import { X as c } from "lucide-react";
import * as l from "react";
import { cn as i } from "./index15.js";
const b = e.Root, h = e.Trigger, m = e.Portal, v = e.Close, r = l.forwardRef(({ className: a, ...t }, s) => /* @__PURE__ */ o(
  e.Overlay,
  {
    ref: s,
    className: i(
      "fixed inset-0 z-50 bg-black/50 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      a
    ),
    ...t
  }
));
r.displayName = e.Overlay.displayName;
const f = l.forwardRef(({ className: a, children: t, ...s }, d) => /* @__PURE__ */ n(m, { children: [
  /* @__PURE__ */ o(r, {}),
  /* @__PURE__ */ n(
    e.Content,
    {
      ref: d,
      className: i(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 bg-surface p-6 shadow-lg duration-200",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]",
        "data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        "rounded-lg border border-border",
        a
      ),
      ...s,
      children: [
        t,
        /* @__PURE__ */ n(e.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-surface transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-brand-accent focus:ring-offset-2 disabled:pointer-events-none", children: [
          /* @__PURE__ */ o(c, { className: "h-4 w-4" }),
          /* @__PURE__ */ o("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
f.displayName = e.Content.displayName;
const p = ({ className: a, ...t }) => /* @__PURE__ */ o("div", { className: i("flex flex-col space-y-1.5 text-center sm:text-left", a), ...t });
p.displayName = "DialogHeader";
const g = ({ className: a, ...t }) => /* @__PURE__ */ o(
  "div",
  {
    className: i("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", a),
    ...t
  }
);
g.displayName = "DialogFooter";
const u = l.forwardRef(({ className: a, ...t }, s) => /* @__PURE__ */ o(
  e.Title,
  {
    ref: s,
    className: i("text-lg font-semibold leading-none tracking-tight text-text", a),
    ...t
  }
));
u.displayName = e.Title.displayName;
const x = l.forwardRef(({ className: a, ...t }, s) => /* @__PURE__ */ o(
  e.Description,
  {
    ref: s,
    className: i("text-sm text-text-muted", a),
    ...t
  }
));
x.displayName = e.Description.displayName;
export {
  b as Dialog,
  v as DialogClose,
  f as DialogContent,
  x as DialogDescription,
  g as DialogFooter,
  p as DialogHeader,
  r as DialogOverlay,
  m as DialogPortal,
  u as DialogTitle,
  h as DialogTrigger
};
//# sourceMappingURL=index9.js.map
